import api from './axiosInstance';

export const orgUnitApi = {
  list: () => api.get('/org-units'),
  listSimple: () => api.get('/org-units/simple'),
  create: (data) => api.post('/org-units', data),
  update: (id, data) => api.put(`/org-units/${id}`, data),
  remove: (id) => api.delete(`/org-units/${id}`),
  getById: (id) => api.get(`/org-units/${id}`),
  uploadImages: (id, logoFile, photoFile) => {
    const formData = new FormData();
    if (logoFile) {
      formData.append('logo', {
        uri: logoFile.uri,
        type: logoFile.type || 'image/jpeg',
        name: logoFile.fileName || 'logo.jpg',
      });
    }
    if (photoFile) {
      formData.append('photo', {
        uri: photoFile.uri,
        type: photoFile.type || 'image/jpeg',
        name: photoFile.fileName || 'photo.jpg',
      });
    }
    return api.post(`/org-units/${id}/images`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    });
  },
};
